/*
  PHN native configurator. 16 Sep 2026 (v2: four products).
  Companion to snippets/phn-configurator.liquid. See that file's header comment
  for how pricing and line-item properties work, and for the render arguments
  that select the product behaviour (config JSON below).

  Two kinds:
    letters  Custom Numbers and Letters, Script Handwritten Font, Grandfathered
             Fonts. Height variants priced per character, quantity = billable
             characters. Width estimate + scaled preview.
    sign     House Number Signs. Size variants at a fixed price, quantity 1,
             optional contrast plate (add-on product) and Monument setup fee.
             Plaque preview with the lettering cut out.

  Three font groups for letters:
    standard REG registry below (mm per 100mm of height, from the cut masters)
             plus the production kerning table window.PHNWC_KERN. Identical to
             /pages/width-calculator.
    script   Point Leo, Blairgowrie. Joined lettering: the width is the ink
             width of the whole string scaled so a capital R stands at the
             ordered height (the production anchor). Also from the calculator.
    legacy   The grandfathered fonts. No registry exists, so each glyph's width
             is measured from the webfont and scaled so a capital H stands at
             the ordered height. Quoted as approximate.

  Preview: drawn on an overlay over the theme's main product photo
  (.product__main-photos), with its own thumbnail at the top of the theme's
  thumbnail strip. Clicking any photo thumbnail or slider dot shows that photo;
  clicking the preview thumbnail, or changing any option, brings the preview
  back. On phones a small "Show my design" tab does the same.
*/
(function () {
  'use strict';

  var REG = {"Flinders":{"1":33.671,"2":68.556,"3":61.007,"4":75.393,"5":69.14,"6":66.781,"7":69.434,"8":60.32,"9":66.781,"0":71.941,"A":88.53,"B":61.578,"C":80.429,"D":80.569,"E":57.549,"F":51.794,"G":96.513,"H":79.85,"I":12.229,"J":39.431,"K":68.475,"L":51.794,"M":101.015,"N":84.341,"O":99.312,"P":61.578,"Q":105.416,"R":67.141,"S":64.898,"T":64.024,"U":67.519,"V":89.653,"W":133.599,"X":76.188,"Y":78.533,"Z":72.62,"a":49.696,"b":59.058,"c":50.586,"d":59.058,"e":56.559,"f":33.674,"g":59.101,"h":48.238,"i":13.981,"j":29.242,"k":47.043,"l":10.291,"m":80.073,"n":47.662,"o":60.499,"p":59.101,"q":59.101,"r":33.287,"s":43.319,"t":29.233,"u":47.662,"v":55.386,"w":84.675,"x":52.863,"y":55.388,"z":53.67,"-":27.129,"/":56.254," ":50.0},"Rosebud":{"1":39.777,"2":64.154,"3":63.646,"4":65.357,"5":61.421,"6":66.297,"7":60.881,"8":61.372,"9":66.297,"0":74.758,"A":102.375,"B":87.879,"C":86.285,"D":101.857,"E":82.274,"F":77.496,"G":98.774,"H":107.94,"I":41.934,"J":58.342,"K":96.68,"L":85.51,"M":127.637,"N":104.64,"O":104.955,"P":79.337,"Q":111.218,"R":99.657,"S":67.202,"T":98.983,"U":102.596,"V":102.851,"W":152.679,"X":106.128,"Y":96.033,"Z":91.347,"a":61.362,"b":72.799,"c":54.654,"d":72.285,"e":57.236,"f":59.06,"g":69.235,"h":78.139,"i":34.677,"j":43.317,"k":72.427,"l":33.783,"m":122.151,"n":75.594,"o":66.955,"p":73.434,"q":74.034,"r":52.316,"s":41.157,"t":39.373,"u":75.234,"v":70.435,"w":99.112,"x":70.555,"y":74.874,"z":59.578,"-":39.696,"/":51.534," ":50.0},"Merricks":{"1":22.356,"2":64.29,"3":58.417,"4":71.55,"5":55.345,"6":66.048,"7":62.993,"8":64.567,"9":66.762,"0":82.371,"A":81.16,"B":57.699,"C":76.404,"D":78.295,"E":63.765,"F":56.147,"G":80.157,"H":74.204,"I":6.913,"J":29.859,"K":69.731,"L":61.79,"M":93.815,"N":84.391,"O":100.161,"P":54.172,"Q":102.921,"R":63.798,"S":61.7,"T":65.599,"U":68.216,"V":82.419,"W":123.555,"X":74.358,"Y":80.947,"Z":82.788,"a":55.079,"b":55.473,"c":44.631,"d":55.473,"e":51.802,"f":33.467,"g":55.736,"h":43.905,"i":9.07,"j":15.04,"k":41.461,"l":6.178,"m":80.055,"n":43.905,"o":54.816,"p":55.473,"q":55.473,"r":27.582,"s":34.703,"t":33.126,"u":43.511,"v":51.726,"w":79.518,"x":46.149,"y":51.77,"z":42.129,"-":27.924,"/":55.134," ":50.0},"Somers":{"1":45.085,"2":74.006,"3":71.369,"4":67.628,"5":62.705,"6":65.488,"7":69.099,"8":67.361,"9":65.488,"0":71.369,"A":97.445,"B":77.826,"C":81.575,"D":83.691,"E":73.534,"F":73.391,"G":84.432,"H":80.086,"I":17.453,"J":63.068,"K":69.278,"L":68.526,"M":101.576,"N":83.238,"O":95.933,"P":72.779,"Q":106.034,"R":74.298,"S":67.557,"T":85.143,"U":83.003,"V":89.977,"W":129.637,"X":84.541,"Y":84.277,"Z":76.177,"a":68.355,"b":67.798,"c":61.079,"d":67.798,"e":66.684,"f":48.586,"g":65.709,"h":64.317,"i":17.959,"j":39.537,"k":58.275,"l":30.767,"m":99.399,"n":64.317,"o":70.304,"p":67.659,"q":67.659,"r":46.637,"s":53.817,"t":48.586,"u":64.317,"v":69.445,"w":99.522,"x":63.137,"y":69.64,"z":66.545,"-":48.069,"/":58.404," ":50.0},"Portsea":{"1":34.589,"2":91.841,"3":83.612,"4":91.841,"5":91.841,"6":91.841,"7":83.612,"8":91.841,"9":91.841,"0":105.156,"A":99.756,"B":99.686,"C":90.643,"D":99.686,"E":90.573,"F":90.573,"G":99.756,"H":99.686,"I":18.087,"J":91.617,"K":103.687,"L":91.617,"M":112.916,"N":96.981,"O":104.899,"P":99.686,"Q":104.729,"R":103.156,"S":99.686,"T":97.878,"U":99.756,"V":108.552,"W":131.084,"X":108.95,"Y":99.756,"Z":91.549,"a":77.04,"b":77.885,"c":69.499,"d":77.885,"e":77.04,"f":61.957,"g":77.885,"h":77.885,"i":16.903,"j":54.156,"k":81.568,"l":31.271,"m":100.77,"n":77.885,"o":77.885,"p":77.885,"q":77.885,"r":61.892,"s":70.344,"t":68.589,"u":77.885,"v":83.679,"w":115.451,"x":90.329,"y":77.885,"z":70.337,"-":65.411,"/":81.754," ":50.0}};
  /* Handwritten fonts, as on the width calculator page. quoteFix: Point Leo only has the
     curly apostrophe, so a straight one is swapped before measuring. */
  var SCRIPT = {"Point Leo": {"quoteFix": "\u2019"}, "Blairgowrie": {"quoteFix": null}};
  /* House number sign models, keyed by the product's Size option value. Fit rules and
     character caps mirror sign_generator.py and the width calculator's sign mode
     (rect 90%/55%, square 78%/48%, circle text-block diagonal = 72% of diameter).
     model = the key the mockup service expects. */
  var SIGNS = {
    "Circle 150mm diameter":  {model: "Circle150",   w: 150, h: 150, shape: "circle", max: 5,  name: "Circle",    dims: "150mm"},
    "Circle 200mm diameter":  {model: "Circle200",   w: 200, h: 200, shape: "circle", max: 6,  name: "Circle",    dims: "200mm"},
    "Circle 250mm diameter":  {model: "Circle250",   w: 250, h: 250, shape: "circle", max: 7,  name: "Circle",    dims: "250mm"},
    "Rectangle 200x75mm":     {model: "Rect200x75",  w: 200, h: 75,  shape: "rect",   max: 8,  name: "Rectangle", dims: "200 x 75mm"},
    "Rectangle 300x100mm":    {model: "Rect300x100", w: 300, h: 100, shape: "rect",   max: 9,  name: "Rectangle", dims: "300 x 100mm"},
    "Rectangle 400x150mm":    {model: "Rect400x150", w: 400, h: 150, shape: "rect",   max: 12, name: "Rectangle", dims: "400 x 150mm"},
    "Square 200x200mm":       {model: "Square200",   w: 200, h: 200, shape: "square", max: 6,  name: "Square",    dims: "200 x 200mm"}
  };
  var SIZE_NAMES = {150: "small", 200: "medium", 300: "large", 400: "extra large"};
  var LEGACY_CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-/";
  var GINK_S = 600;

  function init(root) {
    if (root.dataset.phnReady) return;
    root.dataset.phnReady = '1';

    var cfg = JSON.parse(root.querySelector('[data-phn-config]').textContent);
    var KIND = cfg.kind === 'sign' ? 'sign' : 'letters';
    var GROUP = cfg.fontGroup || 'standard';
    var FONTS = (cfg.fonts && cfg.fonts.length) ? cfg.fonts : ['Flinders', 'Rosebud', 'Merricks', 'Somers', 'Portsea'];
    var isScript = GROUP === 'script', isLegacy = GROUP === 'legacy', isSign = KIND === 'sign';
    var SAMPLE = (cfg.sample && String(cfg.sample).trim()) || '247';   /* text shown on the font tiles before the customer types */
    var form = document.getElementById(root.dataset.formId);
    var q = function (sel) { return root.querySelector(sel); };
    var qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
    var fontStack = function (f) { return isSign ? "'" + f + " Stencil'" : "'" + f + "'"; };

    /* ---------- variants and money ---------- */
    /* Letters products carry Height as option 1 and, since 17 Sep 2026, Characters (1..N) as
       option 2, one variant per combination priced at count x the per-character rate. That
       puts the whole design on one cart line at quantity 1, the shape Zepto produced and the
       one the packing slips and batch scripts expect. byHeight[h][n] is the variant for n
       characters; byHeight[h][1] carries the per-character rate. If a product has no
       Characters option yet, or a count's variant is missing or not yet priced, the add falls
       back to the height/1 variant at quantity = characters (the 16 Sep shape), so the price
       is right either way. */
    var byHeight = {}, byModel = {}, MAXN = 1;
    (cfg.variants || []).forEach(function (v) {
      var opt = String(v.option || '');
      if (isSign) { if (SIGNS[opt]) byModel[opt] = v; return; }
      var m = opt.match(/(\d+)\s*mm/i); if (!m) return;
      var h = parseInt(m[1], 10), n = parseInt(v.option2, 10); if (!(n > 0)) n = 1;
      (byHeight[h] = byHeight[h] || {})[n] = v;
      if (n > MAXN) MAXN = n;
    });
    var HEIGHTS = (cfg.heights || [100, 150, 200, 300, 400]).filter(function (h) { return byHeight[h] && byHeight[h][1]; });
    var CHAR_CAP = MAXN > 1 ? MAXN : 50;   /* billable characters allowed online */
    var MODELS = Object.keys(SIGNS).filter(function (k) { return byModel[k]; });
    if ((isSign && !MODELS.length) || (!isSign && !HEIGHTS.length)) {
      root.innerHTML = '<p class="phn-cfg__error">This product is not set up with its ' + (isSign ? 'size' : 'height') + ' variants yet.</p>';
      return;
    }
    function unitCents(h) { return byHeight[h][1].price; }
    /* the variant and quantity to add for n characters at height h (see byHeight above) */
    function pick(h, n) {
      var v = byHeight[h][n];
      if (v && v.price === n * unitCents(h)) return { variant: v, qty: 1 };
      return { variant: byHeight[h][1], qty: n };
    }
    function money(cents) {
      if (window.theme && theme.Currency && theme.Currency.formatMoney) {
        return theme.Currency.formatMoney(cents, cfg.moneyFormat || '${{amount}}');
      }
      return '$' + (cents / 100).toFixed(2);
    }
    function money0(cents) {
      var s = money(cents);
      return (cents % 100 === 0) ? s.replace(/\.00(?=\D*$)/, '') : s;
    }

    /* ---------- state ---------- */
    var params = new URLSearchParams(location.search);
    var urlH = parseInt(params.get('height'), 10);
    var state = {
      height: HEIGHTS.indexOf(urlH) > -1 ? urlH : (HEIGHTS.indexOf(cfg.defaultHeight) > -1 ? cfg.defaultHeight : HEIGHTS[0]),
      model: MODELS.indexOf(params.get('sign')) > -1 ? params.get('sign') : (MODELS.indexOf(cfg.defaultModel) > -1 ? cfg.defaultModel : MODELS[0]),
      text: (params.get('text') || '').slice(0, 50),
      font: FONTS.indexOf(params.get('font')) > -1 ? params.get('font') : FONTS[0],
      finish: 0,
      plate: ''
    };
    var FIN = cfg.finishes;
    var PLATES = cfg.plates || {};
    var plateHex = {"Matt White": "#ececec", "Matt Black": "#1a1a1a"};
    function signModel() { return SIGNS[state.model]; }
    function signMax() { return isSign ? signModel().max : 250; }

    /* ---------- pixel-scan measurement (shared) ---------- */
    var _scan = document.createElement('canvas');
    var _sctx = _scan.getContext('2d', { willReadFrequently: true });
    var _gcache = {}, _bcache = {}, _rcache = {}, _lcache = {};
    /* tight ink box of a whole string, offsets from the pen origin */
    function inkBox(fam, text, S) {
      var key = fam + '|' + S + '|' + text;
      if (_bcache[key] !== undefined) return _bcache[key];
      var pad = Math.ceil(S * 0.7);
      _sctx.font = S + 'px ' + fam;
      var adv = _sctx.measureText(text).width;
      var W = Math.max(2, Math.ceil(adv) + 2 * pad), Hpx = Math.ceil(S * 2.8);
      _scan.width = W; _scan.height = Hpx;
      _sctx.font = S + 'px ' + fam; _sctx.textAlign = 'left'; _sctx.textBaseline = 'alphabetic'; _sctx.fillStyle = '#000';
      var penX = pad, penY = Math.round(Hpx * 0.6);
      _sctx.fillText(text, penX, penY);
      var d = _sctx.getImageData(0, 0, W, Hpx).data;
      var xmin = W, xmax = -1, ymin = Hpx, ymax = -1;
      for (var y = 0; y < Hpx; y++) { var o = (y * W) * 4 + 3; for (var x = 0; x < W; x++, o += 4) { if (d[o] > 110) { if (x < xmin) xmin = x; if (x > xmax) xmax = x; if (y < ymin) ymin = y; if (y > ymax) ymax = y; } } }
      var r = (xmax < 0) ? null : { l: xmin - penX, t: ymin - penY, w: xmax - xmin + 1, h: ymax - ymin + 1 };
      _bcache[key] = r; return r;
    }
    /* tight ink box of one glyph at GINK_S (left offset + width), for slot placement */
    function glyphInk(font, ch) {
      var key = font + '|' + ch;
      if (_gcache[key] !== undefined) return _gcache[key];
      var S = GINK_S, pad = Math.ceil(S * 0.6);
      _sctx.font = S + 'px ' + fontStack(font);
      var adv = _sctx.measureText(ch).width;
      var W = Math.max(2, Math.ceil(adv) + 2 * pad), Hpx = Math.ceil(S * 2.4);
      _scan.width = W; _scan.height = Hpx;
      _sctx.font = S + 'px ' + fontStack(font); _sctx.textAlign = 'left'; _sctx.textBaseline = 'alphabetic'; _sctx.fillStyle = '#000';
      var penX = pad, penY = Math.round(Hpx * 0.72);
      _sctx.fillText(ch, penX, penY);
      var d = _sctx.getImageData(0, 0, W, Hpx).data;
      var x0 = W, x1 = -1;
      for (var y = 0; y < Hpx; y++) { var o = (y * W) * 4 + 3; for (var x = 0; x < W; x++, o += 4) { if (d[o] > 110) { if (x < x0) x0 = x; if (x > x1) x1 = x; } } }
      var r = (x1 < 0) ? null : { l: x0 - penX, w: x1 - x0 + 1 };
      _gcache[key] = r; return r;
    }
    /* script fonts: capital R height at the 480px basis, the production height anchor */
    function scriptRef(font) {
      if (_rcache[font] !== undefined) return _rcache[font];
      var SR = 2400, b = inkBox(fontStack(font), 'R', SR);
      var h = b ? b.h * (480 / SR) : 0;
      _rcache[font] = h; return h;
    }
    /* legacy fonts: a registry measured from the webfont, capital H = ordered height */
    function legacyReg(font) {
      if (_lcache[font]) return _lcache[font];
      var cap = inkBox(fontStack(font), 'H', GINK_S);
      if (!cap || !cap.h) return null;
      var reg = {};
      Array.from(LEGACY_CHARS).forEach(function (ch) { var g = glyphInk(font, ch); if (g && g.w > 1) reg[ch] = g.w / cap.h * 100; });
      reg[' '] = 50;
      _lcache[font] = reg; return reg;
    }
    function regFor(font) { return isLegacy ? legacyReg(font) : REG[font]; }

    /* ---------- width engine ---------- */
    var kernAdj = function (font, a, b, H) {
      if (a === ' ' || b === ' ') return 0;
      var K = window.PHNWC_KERN && window.PHNWC_KERN[font];
      var v = K && K[a + b];
      return v ? v * H / 100 : 0;
    };
    var hasKern = function (font) { return !!(window.PHNWC_KERN && window.PHNWC_KERN[font]); };
    function compute(font, text, H) {
      if (!text) return { mm: 0, per: [], missing: [], kern: 0, anchor: '' };
      if (isScript) {
        var cfgS = SCRIPT[font] || {};
        if (cfgS.quoteFix) text = text.replace(/['\u2019]/g, cfgS.quoteFix);
        var S = (text.length <= 4) ? 960 : 480;
        var full = inkBox(fontStack(font), text, S), href = scriptRef(font);
        return { mm: (full && href > 0) ? full.w * (480 / S) / href * H : 0, per: [], missing: [], kern: 0, anchor: 'capital height, joined lettering' };
      }
      var base = regFor(font); if (!base) return { mm: 0, per: [], missing: [], kern: 0, anchor: '' };
      var total = 0, per = [], missing = [];
      var chars = Array.from(text);
      chars.forEach(function (ch) {
        if (Object.prototype.hasOwnProperty.call(base, ch)) { var w = base[ch] * H / 100; total += w; per.push({ ch: ch, w: w }); }
        else { missing.push(ch); per.push({ ch: ch, w: null }); }
      });
      total += (chars.length - 1) * (H / 10);
      var kern = 0;
      for (var i = 0; i < chars.length - 1; i++) kern += kernAdj(font, chars[i], chars[i + 1], H);
      total += kern;
      return { mm: total, kern: kern, per: per, missing: missing, anchor: isLegacy ? 'approximate' : (hasKern(font) ? 'optically kerned' : 'standard spacing') };
    }
    function lum(hex) { var n = parseInt(hex.slice(1), 16); return (0.2126 * ((n >> 16) & 255) + 0.7152 * ((n >> 8) & 255) + 0.0722 * (n & 255)) / 255; }

    /* ---------- drawing ---------- */
    var DIM = '#c44646';
    function dimH(ctx, x0, x1, y, label, fs, ah, lw) {
      ctx.strokeStyle = DIM; ctx.fillStyle = DIM; ctx.lineWidth = lw;
      ctx.beginPath(); ctx.moveTo(x0, y); ctx.lineTo(x1, y); ctx.stroke();
      [[x0, 1], [x1, -1]].forEach(function (p) { ctx.beginPath(); ctx.moveTo(p[0], y); ctx.lineTo(p[0] + p[1] * ah, y - ah * 0.55); ctx.lineTo(p[0] + p[1] * ah, y + ah * 0.55); ctx.closePath(); ctx.fill(); });
      ctx.font = '600 ' + Math.round(22 * fs) + 'px "Saans Medium",Helvetica,Arial,sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'alphabetic';
      ctx.fillText(label, (x0 + x1) / 2, y - 8 * fs);
    }
    function dimV(ctx, x, y0, y1, label, fs, ah, lw) {
      ctx.strokeStyle = DIM; ctx.fillStyle = DIM; ctx.lineWidth = lw;
      ctx.beginPath(); ctx.moveTo(x, y0); ctx.lineTo(x, y1); ctx.stroke();
      [[y0, 1], [y1, -1]].forEach(function (p) { ctx.beginPath(); ctx.moveTo(x, p[0]); ctx.lineTo(x - ah * 0.55, p[0] + p[1] * ah); ctx.lineTo(x + ah * 0.55, p[0] + p[1] * ah); ctx.closePath(); ctx.fill(); });
      ctx.font = '600 ' + Math.round(18 * fs) + 'px "Saans Medium",Helvetica,Arial,sans-serif'; ctx.textAlign = 'left'; ctx.textBaseline = 'alphabetic';
      ctx.fillText(label, x + 8 * fs, (y0 + y1) / 2 + 6 * fs);
    }
    /* Scale and baseline come from ALL of the product's fonts for this text, not just the
       selected one, so switching fonts changes the width only: the capital height on screen
       and the baseline stay put (Simon, 17 Sep: the lettering looked as if it grew and
       shrank and the baseline jumped between fonts, because a wide font had to be shrunk
       to fit and a narrow one did not). Returns the capital height in px, the baseline y,
       and the tallest ascent/descent over all fonts (script loops and tails). */
    function fitAll(text, H, usableW, Hpx) {
      var cap = Hpx * 0.50, asc = 0, desc = 0;
      if (isScript) {
        var boxes = [];
        FONTS.forEach(function (f) {
          var cfgS = SCRIPT[f] || {}, tf = cfgS.quoteFix ? text.replace(/['\u2019]/g, cfgS.quoteFix) : text;
          var href = scriptRef(f), b = inkBox(fontStack(f), tf, 480);
          if (!href || !b || !b.w || !b.h) return;
          boxes.push({ href: href, b: b });
          cap = Math.min(cap, usableW * href / b.w, Hpx * 0.6 * href / b.h);
        });
        boxes.forEach(function (o) { var k = cap / o.href; asc = Math.max(asc, -o.b.t * k); desc = Math.max(desc, (o.b.t + o.b.h) * k); });
        return { cap: cap, baseY: Hpx * 0.44 - (asc + desc) / 2 + asc, asc: asc, desc: desc };
      }
      FONTS.forEach(function (f) { var mm = compute(f, text, H).mm; if (mm > 0) cap = Math.min(cap, usableW / mm * H); });
      return { cap: cap, baseY: Hpx * 0.5 + cap / 2, asc: cap, desc: 0 };
    }
    function draw(cv, font, text, H, hex) {
      if (!cv) return;
      var ctx = cv.getContext('2d'), W = cv.width, Hpx = cv.height;
      var fs = Math.max(1.15, W / 640), lw = Math.max(2, W / 600), ah = Math.max(9, W / 100);
      ctx.clearRect(0, 0, W, Hpx);
      if (!text) return;
      var marginL = Math.round(W * 0.06), marginR = Math.round(W * 0.06 + 64 * fs), usableW = W - marginL - marginR;
      var r = compute(font, text, H), totalMm = r.mm; if (totalMm <= 0) return;
      var light = lum(hex) > 0.8;
      var fit = fitAll(text, H, usableW, Hpx), capPx = fit.cap, pxPerMm = capPx / H;
      var totalPx = totalMm * pxPerMm, startX = marginL + (usableW - totalPx) / 2, baseY = fit.baseY, x = startX;
      ctx.textBaseline = 'alphabetic'; ctx.textAlign = 'left';
      if (isScript) {
        /* Handwritten fonts: the whole string is drawn at the size where a capital R stands
           capPx tall (the ordered height). The dashed box wraps the FULL lettering, tails and
           loops included, the width runs under that box, and the height arrow on the right
           spans only the capital height, so the picture says what the hint says. */
        var cfgS = SCRIPT[font] || {}, t = cfgS.quoteFix ? text.replace(/['\u2019]/g, cfgS.quoteFix) : text;
        var href = scriptRef(font); if (!href) return;
        var b = inkBox(fontStack(font), t, 480); if (!b) return;
        var k = capPx / href;
        var inkW = b.w * k, inkHt = b.h * k;
        startX = marginL + (usableW - inkW) / 2;
        var inkTop = baseY + b.t * k, inkBot = inkTop + inkHt, inkR = startX + inkW;
        ctx.font = (480 * k) + 'px ' + fontStack(font); ctx.fillStyle = hex;
        var penX = startX - b.l * k;
        /* light finishes get a soft shadow rather than an outline: an outline traces every
           glyph, and on joined lettering that shows the joins as if the letters were separate */
        if (light) { ctx.shadowColor = 'rgba(0,0,0,.32)'; ctx.shadowBlur = 5 * fs; ctx.shadowOffsetY = 1.5 * fs; }
        ctx.fillText(t, penX, baseY);
        ctx.shadowColor = 'transparent'; ctx.shadowBlur = 0; ctx.shadowOffsetY = 0;
        ctx.strokeStyle = DIM; ctx.setLineDash([6 * fs, 5 * fs]); ctx.lineWidth = lw; ctx.strokeRect(startX, inkTop, inkW, inkHt); ctx.setLineDash([]);
        dimH(ctx, startX, inkR, Math.min(Hpx - 14 * fs, baseY + fit.desc + 34 * fs), Math.round(totalMm) + ' mm', fs, ah, lw);
        dimV(ctx, inkR + 10 * fs, baseY - capPx, baseY, H + ' mm', fs, ah, lw);
        return;
      } else {
        var base = regFor(font); if (!base) return;
        ctx.font = GINK_S + 'px ' + fontStack(font);
        var chars = Array.from(text);
        for (var i = 0; i < chars.length; i++) {
          var ch = chars[i], wmm = Object.prototype.hasOwnProperty.call(base, ch) ? base[ch] * H / 100 : 0, slot = wmm * pxPerMm;
          if (ch !== ' ' && wmm > 0) {
            var gi = glyphInk(font, ch);
            if (gi && gi.w > 0) {
              var kk = slot / gi.w;
              ctx.save(); ctx.translate(x, baseY); ctx.scale(kk, kk);
              ctx.fillStyle = hex; ctx.fillText(ch, -gi.l, 0);
              if (light) { ctx.lineWidth = 2 / kk; ctx.strokeStyle = 'rgba(0,0,0,.28)'; ctx.strokeText(ch, -gi.l, 0); }
              ctx.restore();
            }
          }
          x += slot; if (i < chars.length - 1) x += ((H / 10) + kernAdj(font, ch, chars[i + 1], H)) * pxPerMm;
        }
      }
      ctx.strokeStyle = DIM; ctx.setLineDash([6 * fs, 5 * fs]); ctx.lineWidth = lw; ctx.strokeRect(startX, baseY - capPx, x - startX, capPx); ctx.setLineDash([]);
      var y = Math.min(Hpx - 14 * fs, baseY + 34 * fs);
      dimH(ctx, startX, x, y, Math.round(totalMm) + ' mm', fs, ah, lw);
      var hx = x + 10 * fs;
      dimV(ctx, hx, baseY - capPx, baseY, H + ' mm', fs, ah, lw);
    }
    function signFit(m, tw, th) {
      if (m.shape === 'circle') return 0.72 * m.w / Math.hypot(tw, th);
      if (m.shape === 'square') return Math.min(0.78 * m.w / tw, 0.48 * m.h / th);
      return Math.min(0.90 * m.w / tw, 0.55 * m.h / th);
    }
    /* plaque preview: the plate in the chosen finish, the lettering cut out so the
       contrast plate (or the wall) shows through, dimensioned */
    function drawSign(cv, font, text, hex, plate, withDims) {
      if (!cv) return;
      var ctx = cv.getContext('2d'), W = cv.width, Hpx = cv.height, m = signModel();
      var fs = Math.max(1.15, W / 640), lw = Math.max(2, W / 600), ah = Math.max(9, W / 100);
      ctx.clearRect(0, 0, W, Hpx);
      var mL = W * 0.08, mR = withDims ? W * 0.08 + 64 * fs : W * 0.08, mT = Hpx * 0.1, mB = withDims ? Hpx * 0.1 + 46 * fs : Hpx * 0.1;
      var pxmm = Math.min((W - mL - mR) / m.w, (Hpx - mT - mB) / m.h);
      var PW = m.w * pxmm, PH = m.h * pxmm, cx = mL + (W - mL - mR) / 2, cy = mT + (Hpx - mT - mB) / 2;
      var light = lum(hex) > 0.8;
      ctx.fillStyle = hex; ctx.strokeStyle = light ? 'rgba(0,0,0,.25)' : 'rgba(0,0,0,.08)'; ctx.lineWidth = Math.max(1, W / 500);
      ctx.beginPath();
      if (m.shape === 'circle') ctx.arc(cx, cy, PW / 2, 0, 2 * Math.PI); else ctx.rect(cx - PW / 2, cy - PH / 2, PW, PH);
      ctx.fill(); ctx.stroke();
      if (text) {
        var fam = fontStack(font), ink = inkBox(fam, text, 480);
        if (ink && ink.w && ink.h) {
          var s = signFit(m, ink.w, ink.h), F = 480 * s * pxmm, k = F / 480;
          ctx.font = F + 'px ' + fam; ctx.textAlign = 'left'; ctx.textBaseline = 'alphabetic';
          ctx.fillStyle = plate ? (plateHex[plate] || '#ececec') : '#efede6';
          ctx.fillText(text, cx - (ink.l + ink.w / 2) * k, cy - (ink.t + ink.h / 2) * k);
          if (!plate && light) { ctx.lineWidth = 1; ctx.strokeStyle = 'rgba(0,0,0,.25)'; ctx.strokeText(text, cx - (ink.l + ink.w / 2) * k, cy - (ink.t + ink.h / 2) * k); }
        }
      }
      if (!withDims) return;
      var y = cy + PH / 2 + 34 * fs;
      dimH(ctx, cx - PW / 2, cx + PW / 2, y, m.w + ' mm' + (m.shape === 'circle' ? ' diameter' : ''), fs, ah, lw);
      if (m.shape !== 'circle') dimV(ctx, cx + PW / 2 + 10 * fs, cy - PH / 2, cy + PH / 2, m.h + ' mm', fs, ah, lw);
    }

    /* ---------- pricing ---------- */
    var billable = function (t) { return Array.from(t.replace(/\s/g, '')).length; };
    function price() {
      var fin = FIN[state.finish], feeCents = (fin.fee || 0) * 100;
      if (isSign) {
        var v = byModel[state.model], plateCents = state.plate ? 7000 : 0, n = billable(state.text);
        return { n: n, unit: v.price, line: v.price, fee: feeCents, plate: plateCents, total: v.price + plateCents + feeCents, fin: fin, variant: v };
      }
      var nn = billable(state.text), unit = unitCents(state.height);
      return { n: nn, unit: unit, line: nn * unit, fee: feeCents, plate: 0, total: nn * unit + feeCents, fin: fin, variant: byHeight[state.height][1], over: nn > CHAR_CAP };
    }
    /* hidden property values, identical to what Zepto wrote for each product */
    function heightLabel(h) {
      if (cfg.heightStyle === 'size') return h + 'mm [' + (SIZE_NAMES[h] || 'custom') + ']';
      var dollars = Math.round(unitCents(h) / 100);
      return h + 'mm - $' + dollars + ' each' + (h === 150 ? ' [most popular]' : '');
    }
    function signLabel(k) { return k + ' - $' + Math.round(byModel[k].price / 100); }
    function finishLabel(fin) { return fin.n + (fin.fee ? ' [$' + fin.fee + ' extra per order]' : ''); }
    function plateLabel(p) { return p + ' contrast plate +$70'; }

    /* ---------- build controls ---------- */
    var overlayDismissed = false;
    if (isSign) {
      q('[data-phn-heights]').innerHTML = MODELS.map(function (k) {
        var m = SIGNS[k];
        return '<button type="button" class="phn-cfg__tile phn-cfg__tile--sign" role="radio" data-m="' + k + '" aria-checked="false">' +
          '<span class="shape shape--' + m.shape + '" aria-hidden="true"></span>' +
          '<span class="h">' + m.name + '</span><span class="d phn-num">' + m.dims + '</span><span class="p phn-num">' + money0(byModel[k].price) + '</span></button>';
      }).join('');
      qa('[data-phn-heights] .phn-cfg__tile').forEach(function (b) { b.addEventListener('click', function () { state.model = b.dataset.m; overlayDismissed = false; update(); }); });
    } else {
      q('[data-phn-heights]').innerHTML = HEIGHTS.map(function (h) {
        return '<button type="button" class="phn-cfg__tile" role="radio" data-h="' + h + '" aria-checked="false">' +
          (h === cfg.popularHeight ? '<span class="pop">Most popular</span>' : '') +
          '<span class="h phn-num">' + h + 'mm</span><span class="p phn-num">' + money0(unitCents(h)) + ' each</span></button>';
      }).join('');
      qa('[data-phn-heights] .phn-cfg__tile').forEach(function (b) { b.addEventListener('click', function () { state.height = parseInt(b.dataset.h, 10); overlayDismissed = false; update(); }); });
    }

    q('[data-phn-fonts]').innerHTML = FONTS.map(function (f) {
      return '<button type="button" class="phn-cfg__fonttile" role="radio" data-f="' + f + '" aria-checked="false"><span class="g" style="font-family:' + fontStack(f).replace(/"/g, '&quot;') + '">' + SAMPLE + '</span><span class="n">' + f + '</span></button>';
    }).join('');
    qa('[data-phn-fonts] .phn-cfg__fonttile').forEach(function (b) { b.addEventListener('click', function () { state.font = b.dataset.f; overlayDismissed = false; update(); }); });
    /* the tiles share one CSS font size, but fonts differ in how tall their capitals are for a
       given size (Blairgowrie draws about a third larger than Point Leo). Once the webfonts are in,
       each tile is scaled so its capital height matches the first font's, so the samples look the
       same size. Script fonts measure the capital R (the production anchor), the rest a capital H. */
    function capPx(font) { var b = inkBox(fontStack(font), isScript ? 'R' : 'H', 200); return b ? b.h : 0; }
    function sizeTiles() {
      var ref = capPx(FONTS[0]); if (!ref) return;
      qa('[data-phn-fonts] .phn-cfg__fonttile').forEach(function (b) { var h = capPx(b.dataset.f); b.querySelector('.g').style.fontSize = h ? (30 * ref / h).toFixed(2) + 'px' : ''; });
    }

    q('[data-phn-finishes]').innerHTML = FIN.map(function (f, i) {
      return '<button type="button" class="phn-cfg__swatch' + (f.fee ? ' phn-cfg__swatch--fee' : '') + '" role="radio" data-i="' + i + '" aria-checked="false" aria-label="' + f.n + (f.fee ? ' (+$' + f.fee + ' per order)' : '') + '" title="' + f.n + '" style="background:' + f.hex + '"></button>';
    }).join('');
    qa('[data-phn-finishes] .phn-cfg__swatch').forEach(function (b) { b.addEventListener('click', function () { state.finish = parseInt(b.dataset.i, 10); overlayDismissed = false; update(); }); });

    var platesEl = q('[data-phn-plates]');
    if (platesEl) {
      var plateOpts = [''].concat(Object.keys(PLATES).filter(function (k) { return PLATES[k]; }));
      platesEl.innerHTML = plateOpts.map(function (p) {
        return '<button type="button" class="phn-cfg__tile phn-cfg__tile--plate" role="radio" data-p="' + p + '" aria-checked="false">' +
          (p ? '<span class="sw" style="background:' + plateHex[p] + '"></span>' : '<span class="sw sw--none"></span>') +
          '<span class="h">' + (p || 'No plate') + '</span><span class="p phn-num">' + (p ? '+ $70' : 'Sign only') + '</span></button>';
      }).join('');
      qa('[data-phn-plates] .phn-cfg__tile').forEach(function (b) { b.addEventListener('click', function () { state.plate = b.dataset.p; overlayDismissed = false; update(); }); });
    }

    var textEl = q('[data-phn-text]');
    textEl.value = state.text;
    textEl.addEventListener('input', function () {
      if (isSign) { var mx = signMax(); if (textEl.value.length > mx) textEl.value = textEl.value.slice(0, mx); }
      state.text = textEl.value; overlayDismissed = false; update();
    });

    /* move the theme's "Help me pick a height" size chart into our height label */
    var slot = q('[data-phn-sizechart-slot]');
    var sizeChart = document.querySelector('.size-chart__standalone');
    if (slot && sizeChart) { slot.appendChild(sizeChart); sizeChart.style.display = ''; sizeChart.style.opacity = '1'; }

    /* ---------- preview overlay on the main product photo ---------- */
    var host = document.querySelector('.product__main-photos') || null;
    var overlay = document.createElement('div');
    overlay.className = 'phn-overlay'; overlay.hidden = true;
    overlay.innerHTML = '<canvas aria-label="Preview of your design at scale with its dimensions marked"></canvas>';
    var overlayCanvas = overlay.querySelector('canvas');
    var backTab = document.createElement('button');
    backTab.type = 'button'; backTab.className = 'phn-overlay__back'; backTab.textContent = 'Show my design'; backTab.hidden = true;
    if (host) {
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      host.appendChild(overlay); host.appendChild(backTab);
    } else {
      var fb = q('[data-phn-preview-fallback]'); if (fb) { fb.hidden = false; fb.appendChild(overlay); }
    }
    backTab.addEventListener('click', function () { overlayDismissed = false; renderOverlay(FIN[state.finish].hex); });

    /* the preview's own thumbnail, first in the theme's thumbnail strip (desktop).
       Impulse's beside-layout strip is a scrolling column (.product__thumbs--scroller);
       the thumbnail goes in as its first child. If the strip is ever a Flickity
       carousel instead, the cell goes in through Flickity's API. */
    var thumbs = document.querySelector('.product__thumbs');
    var myThumb = null, myThumbLink = null, thumbCanvas = null, thumbIn = false;
    if (thumbs) {
      myThumb = document.createElement('div');
      myThumb.className = 'product__thumb-item phn-thumb';
      myThumb.innerHTML = '<a href="#" class="product__thumb phn-thumb__link" aria-label="Show my design"><div class="image-wrap" style="height:0;padding-bottom:100%"><canvas class="phn-thumb__cv" width="160" height="160"></canvas></div></a>';
      myThumbLink = myThumb.querySelector('a'); thumbCanvas = myThumb.querySelector('canvas');
      myThumbLink.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); overlayDismissed = false; renderOverlay(FIN[state.finish].hex); });
      thumbs.addEventListener('click', function (e) { if (e.target.closest('[data-product-thumb]')) { overlayDismissed = true; renderOverlay(FIN[state.finish].hex); } });
    }
    function thumbFlickity() { return (window.Flickity && Flickity.data) ? Flickity.data(thumbs) : null; }
    function setThumb(on) {
      if (!thumbs || on === thumbIn) return;
      var flk = thumbFlickity();
      if (on) {
        if (flk) { flk.prepend(myThumb); } else { var box = thumbs.querySelector('.product__thumbs--scroller') || thumbs.querySelector('.flickity-slider') || thumbs; box.insertBefore(myThumb, box.firstChild); }
      } else {
        if (flk && flk.cells.some(function (c) { return c.element === myThumb; })) { flk.remove(myThumb); } else if (myThumb.parentNode) { myThumb.parentNode.removeChild(myThumb); }
      }
      thumbIn = on;
    }
    document.addEventListener('click', function (e) { if (e.target.closest('.flickity-page-dots')) { overlayDismissed = true; renderOverlay(FIN[state.finish].hex); } });

    function drawThumb(hex) {
      if (!thumbCanvas) return;
      var c = thumbCanvas.getContext('2d'), W = thumbCanvas.width;
      c.clearRect(0, 0, W, W); c.fillStyle = '#efede6'; c.fillRect(0, 0, W, W);
      var txt = state.text.trim();
      if (isSign) { drawSignThumb(c, W, hex, txt); return; }
      if (!txt) return;
      var S = 64; c.font = S + 'px ' + fontStack(state.font);
      var w = c.measureText(txt).width; if (w > W - 24) S = S * (W - 24) / w;
      c.font = S + 'px ' + fontStack(state.font); c.textAlign = 'center'; c.textBaseline = 'middle'; c.fillStyle = hex;
      if (lum(hex) > 0.8) { c.shadowColor = 'rgba(0,0,0,.35)'; c.shadowBlur = 3; c.shadowOffsetY = 1; }
      c.fillText(txt, W / 2, W / 2 + S * 0.06);
      c.shadowColor = 'transparent'; c.shadowBlur = 0; c.shadowOffsetY = 0;
    }
    function drawSignThumb(c, W, hex, txt) {
      var m = signModel(), pad = W * 0.12, pxmm = Math.min((W - 2 * pad) / m.w, (W - 2 * pad) / m.h), PW = m.w * pxmm, PH = m.h * pxmm, cx = W / 2, cy = W / 2;
      c.fillStyle = hex; c.strokeStyle = 'rgba(0,0,0,.2)'; c.lineWidth = 1; c.beginPath();
      if (m.shape === 'circle') c.arc(cx, cy, PW / 2, 0, 2 * Math.PI); else c.rect(cx - PW / 2, cy - PH / 2, PW, PH);
      c.fill(); c.stroke();
      if (!txt) return;
      var fam = fontStack(state.font), ink = inkBox(fam, txt, 480); if (!ink || !ink.w) return;
      var s = signFit(m, ink.w, ink.h), F = 480 * s * pxmm, k = F / 480;
      c.font = F + 'px ' + fam; c.textAlign = 'left'; c.textBaseline = 'alphabetic';
      c.fillStyle = state.plate ? plateHex[state.plate] : '#efede6';
      c.fillText(txt, cx - (ink.l + ink.w / 2) * k, cy - (ink.t + ink.h / 2) * k);
    }
    function renderOverlay(hex) {
      /* the preview replaces the product photo only once the customer has typed something (all kinds) */
      var has = !!state.text.trim(), show = has && !overlayDismissed;
      drawThumb(hex);
      setThumb(has);
      if (myThumb) myThumbLink.classList.toggle('is-active', show);
      if (show && thumbs) {
        Array.prototype.forEach.call(thumbs.querySelectorAll('[data-product-thumb].is-active'), function (a) { a.classList.remove('is-active'); });
        var flk = thumbFlickity(); if (flk && thumbIn) flk.select(0);
        var sc = thumbs.querySelector('.product__thumbs--scroller'); if (sc) sc.scrollTop = 0;
      }
      backTab.hidden = !(has && overlayDismissed && !(thumbs && thumbs.offsetParent));
      overlay.hidden = !show;
      if (!show) return;
      var box = overlay.getBoundingClientRect();
      var cw = Math.max(300, Math.round(box.width || (host ? host.clientWidth : 600)));
      var chh = Math.max(200, Math.round(box.height || cw));
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      overlayCanvas.width = Math.round(cw * dpr); overlayCanvas.height = Math.round(chh * dpr);
      if (isSign) drawSign(overlayCanvas, state.font, state.text.trim(), hex, state.plate, true);
      else draw(overlayCanvas, state.font, state.text, state.height, hex);
    }
    var resizeTimer;
    window.addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(function () { renderOverlay(FIN[state.finish].hex); }, 150); });

    /* ---------- update ---------- */
    var priceEl = document.querySelector('[data-product-price]');
    var atcBtn = form ? form.querySelector('[data-add-to-cart]') : null;
    var atcText = form ? form.querySelector('[data-add-to-cart-text]') : null;
    var missingNow = [];

    function update() {
      var p = price();
      if (isSign) {
        qa('[data-phn-heights] .phn-cfg__tile').forEach(function (b) { b.setAttribute('aria-checked', b.dataset.m === state.model); });
        var mx = signMax(); textEl.maxLength = mx;
        if (state.text.length > mx) { state.text = state.text.slice(0, mx); textEl.value = state.text; }
      } else {
        qa('[data-phn-heights] .phn-cfg__tile').forEach(function (b) { b.setAttribute('aria-checked', parseInt(b.dataset.h, 10) === state.height); });
      }
      qa('[data-phn-fonts] .phn-cfg__fonttile').forEach(function (b) { b.setAttribute('aria-checked', b.dataset.f === state.font); b.querySelector('.g').textContent = state.text.trim() || SAMPLE; });
      qa('[data-phn-finishes] .phn-cfg__swatch').forEach(function (b) { b.setAttribute('aria-checked', parseInt(b.dataset.i, 10) === state.finish); });
      qa('[data-phn-plates] .phn-cfg__tile').forEach(function (b) { b.setAttribute('aria-checked', b.dataset.p === state.plate); });
      q('[data-phn-finishname]').innerHTML = '<span>' + p.fin.n + '</span>' + (p.fin.fee ? '<span class="phn-cfg__feebadge">+ $' + p.fin.fee + ' setup fee, once per order</span>' : '');
      q('[data-phn-charleft]').textContent = Math.max(0, CHAR_CAP - p.n) + ' characters left';

      var r = { mm: 0, missing: [], anchor: '' };
      if (isSign) {
        var m = signModel();
        q('[data-phn-billed]').textContent = p.n ? (state.text.trim().length + ' of ' + m.max + ' characters') : ('Up to ' + m.max + ' characters on this sign');
        q('[data-phn-missing]').textContent = '';
      } else {
        q('[data-phn-billed]').textContent = p.n ? (p.n + (p.n === 1 ? ' character' : ' characters') + ' billed' + (/\s/.test(state.text.trim()) ? ' (spaces are free)' : '')) : 'Type your numbers or letters to see the price';
        r = compute(state.font, state.text, state.height);
        missingNow = [];
        r.missing.forEach(function (c) { var s = c === ' ' ? 'space' : c; if (missingNow.indexOf(s) < 0) missingNow.push(s); });
        q('[data-phn-missing]').textContent = missingNow.length ? 'Not available in this font: ' + missingNow.join(' ') : (p.over ? 'Up to ' + CHAR_CAP + ' characters online. For longer text please contact us.' : '');
        q('[data-phn-wout]').textContent = state.text ? Math.round(r.mm) + ' mm' : '\u2013';
        q('[data-phn-anchor]').textContent = r.anchor || (isLegacy ? 'approximate' : 'standard spacing');
      }

      if (isSign) {
        q('[data-phn-unitline]').innerHTML = signModel().name + ' sign, ' + signModel().dims + '<small>' + state.font + ', ' + p.fin.n + '</small>';
      } else {
        q('[data-phn-unitline]').innerHTML = p.n + ' ' + (p.n === 1 ? 'character' : 'characters') + ' \u00d7 ' + money0(p.unit) + '<small>' + state.height + 'mm ' + state.font + ', ' + p.fin.n + '</small>';
      }
      q('[data-phn-linetotal]').textContent = money(p.line);
      q('[data-phn-feeline]').hidden = !p.fee;
      q('[data-phn-feeamt]').textContent = money(p.fee);
      var pl = q('[data-phn-plateline]');
      if (pl) { pl.hidden = !p.plate; q('[data-phn-platename]').textContent = state.plate ? state.plate + ' contrast plate' : ''; q('[data-phn-plateamt]').textContent = money(p.plate); }
      q('[data-phn-total]').textContent = money(p.total);

      /* theme price block + add-to-cart button */
      if (priceEl) priceEl.textContent = money(p.total);
      if (atcText) atcText.textContent = p.n ? 'ADD TO CART \u2022 ' + money0(p.total) : 'ENTER YOUR TEXT';
      if (atcBtn) atcBtn.disabled = !p.n || missingNow.length > 0 || p.over;
      renderOverlay(p.fin.hex);
      var md = q('[data-phn-mock-design]'); if (md) mockState();
    }

    /* ---------- add to cart ---------- */
    function showError(msg) { var e = q('[data-phn-error]'); e.textContent = msg; e.hidden = !msg; }
    function postCart(body) {
      return fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
        method: 'POST', body: body, credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
      }).then(function (r) { return r.json().then(function (j) { return { status: r.status, json: j }; }); });
    }
    function addOnce(variantId, props) {
      /* add a fee line only if the cart does not already carry it */
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var already = cart.items.some(function (it) { return String(it.variant_id) === String(variantId); });
        if (already) return null;
        var fd2 = new FormData(); fd2.set('id', String(variantId)); fd2.set('quantity', '1');
        Object.keys(props).forEach(function (k) { fd2.set('properties[' + k + ']', props[k]); });
        return postCart(fd2);
      });
    }
    function addToCart() {
      var p = price();
      if (!p.n) { showError('Type your ' + (isSign ? 'sign text' : 'numbers or letters') + ' first.'); return; }
      if (missingNow.length) { showError('Some of those characters are not available in ' + state.font + ': ' + missingNow.join(' ')); return; }
      if (p.over) { showError('Up to ' + CHAR_CAP + ' characters can be ordered online. For longer text please contact us.'); return; }
      showError('');
      if (atcBtn) atcBtn.classList.add('btn--loading');
      var fd = new FormData(form);
      /* C-EDD writes properties[Estimated between]; Zepto orders carried it as _Estimated between, which the Asana due-date rule reads. Keep that name. */
      if (fd.has('properties[Estimated between]')) { fd.set('properties[_Estimated between]', fd.get('properties[Estimated between]')); fd.delete('properties[Estimated between]'); }
      var designDesc;
      if (!isSign) { var pk = pick(state.height, p.n); p.variant = pk.variant; p.qty = pk.qty; }
      fd.set('id', String(p.variant.id));
      if (isSign) {
        var txt = state.text.trim();
        fd.set('quantity', '1');
        fd.set('properties[_1. Choose your sign]', signLabel(state.model));
        fd.set('properties[_2. Enter your text]', txt);
        fd.set('properties[_3. Select your font]', state.font);
        fd.set('properties[_4. Choose your finish]', finishLabel(p.fin));
        if (state.plate) fd.set('properties[_5. Add a contrast plate (optional)]', plateLabel(state.plate));
        designDesc = '"' + txt + '" on a ' + signModel().name.toLowerCase() + ' sign ' + signModel().dims + ' in ' + p.fin.n;
      } else {
        var r = compute(state.font, state.text, state.height);
        fd.set('quantity', String(p.qty));
        fd.set('properties[_1. Choose your height]', heightLabel(state.height));
        fd.set('properties[_2. Enter your text]', state.text);
        fd.set('properties[_3. Select your font]', state.font);
        fd.set('properties[_4. Choose your finish]', finishLabel(p.fin));
        fd.set('properties[Estimated width]', Math.round(r.mm) + ' mm' + (isLegacy ? ' (approx.)' : ''));
        fd.set('properties[_phn_chars]', String(p.n));
        designDesc = '"' + state.text + '" in ' + p.fin.n;
      }
      var feeId = p.fee ? cfg.fees[String(p.fin.fee)] : null;
      var plateId = (isSign && state.plate) ? PLATES[state.plate] : null;
      postCart(fd).then(function (res) {
        if (res.status !== 200) throw new Error(res.json && (res.json.description || res.json.message) || 'Could not add to cart.');
        var added = res.json;
        var chain = Promise.resolve();
        if (plateId) chain = chain.then(function () {
          var fdp = new FormData(); fdp.set('id', String(plateId)); fdp.set('quantity', '1'); fdp.set('properties[_For]', designDesc);
          return postCart(fdp).then(function (r2) { if (r2.status !== 200) throw new Error('The sign was added, but the contrast plate could not be. Please add it from the cart or contact us.'); });
        });
        if (feeId) chain = chain.then(function () { return addOnce(feeId, { '_For': designDesc }); });
        return chain.then(function () { return added; });
      }).then(function (added) {
        if (atcBtn) atcBtn.classList.remove('btn--loading');
        form.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: added, addToCartBtn: atcBtn }, bubbles: true }));
        if (document.body.classList.contains('template-cart')) location.reload();
        if (!(window.theme && theme.settings && theme.settings.cartType === 'drawer')) { window.location.href = (theme.routes && theme.routes.cartPage) || '/cart'; }
      }).catch(function (err) {
        if (atcBtn) atcBtn.classList.remove('btn--loading');
        showError(err.message || 'Could not add to cart. Please try again.');
      });
    }
    if (form) {
      document.addEventListener('submit', function (evt) {
        if (evt.target !== form) return;
        evt.preventDefault(); evt.stopImmediatePropagation();
        addToCart();
      }, true);
    }

    /* ---------- print-at-home mockup ---------- */
    var mockToggle = q('[data-phn-mockup-toggle]');
    /* same rule as the mockup service: dot-separated labels, 2+ letter TLD, so "hotmail..com" is caught here, not by Gmail */
    var EMAIL_OK = /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/;
    var mockBusy = false;
    function mockState() {
      var email = q('[data-phn-mock-email]'), send = q('[data-phn-mock-send]'), design = q('[data-phn-mock-design]');
      if (!email) return;
      send.disabled = mockBusy || !(EMAIL_OK.test(email.value.trim()) && billable(state.text));
      var t = state.text.trim();
      design.textContent = t ? ('Design: \u201c' + t + '\u201d ' + (isSign ? ('on a ' + signModel().name.toLowerCase() + ' sign ' + signModel().dims + ' in ' + state.font) : ('in ' + state.font + ', ' + state.height + 'mm')) + ', ' + FIN[state.finish].n) : 'Enter your text above first.';
    }
    if (mockToggle) {
      var panel = q('[data-phn-mockpanel]');
      var toggle = function () { panel.hidden = !panel.hidden; mockToggle.setAttribute('aria-expanded', String(!panel.hidden)); if (!panel.hidden) { mockState(); q('[data-phn-mock-email]').focus(); } };
      mockToggle.addEventListener('click', toggle);
      mockToggle.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
      q('[data-phn-mock-email]').addEventListener('input', mockState);
      q('[data-phn-mock-send]').addEventListener('click', function () {
        var email = q('[data-phn-mock-email]').value.trim(), st = q('[data-phn-mock-status]'), t = state.text.trim();
        var payload = { text: t, font: state.font, email: email, consent: q('[data-phn-mock-consent]').checked };
        if (isSign) payload.sign_model = signModel().model; else payload.size_mm = state.height;
        mockBusy = true; mockState();
        st.hidden = false; st.className = 'phn-cfg__mock-status phn-cfg__mock-status--busy'; st.textContent = 'Building your mockup\u2026 this takes a few seconds.';
        var mailto = 'mailto:hello@housenumbers.com.au?subject=' + encodeURIComponent('Print-at-home mockup request: "' + t + '" (' + (isSign ? signModel().name + ' ' + signModel().dims + ', ' : '') + state.font + (isSign ? '' : ' ' + state.height + 'mm') + ')');
        fetch(cfg.mockupUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
          .then(function (r) { return r.json().then(function (j) { return { s: r.status, j: j }; }); })
          .then(function (res) {
            mockBusy = false; mockState();
            if (res.s === 200 && res.j.ok) { st.className = 'phn-cfg__mock-status phn-cfg__mock-status--ok'; st.innerHTML = 'Done! Your print-at-home mockup is on its way to <b>' + email.replace(/</g, '&lt;') + '</b>. Check your inbox, and the spam folder, within a couple of minutes.'; }
            else { st.className = 'phn-cfg__mock-status phn-cfg__mock-status--err'; st.innerHTML = ((res.j && res.j.detail) ? res.j.detail : 'Something went wrong.') + ' You can also <a href="' + mailto + '">email us directly</a>.'; }
          })
          .catch(function () { mockBusy = false; mockState(); st.className = 'phn-cfg__mock-status phn-cfg__mock-status--err'; st.innerHTML = 'We couldn\u2019t reach the mockup service. Please <a href="' + mailto + '">email us directly</a> and we\u2019ll send it by hand.'; });
      });
    }

    /* ---------- go ---------- */
    update();
    if (document.fonts && document.fonts.load) {
      Promise.all(FONTS.map(function (f) { return document.fonts.load('40px ' + fontStack(f)); })).then(function () { return document.fonts.ready; }).then(function () { _gcache = {}; _bcache = {}; _rcache = {}; _lcache = {}; sizeTiles(); update(); }).catch(function () {});
    }
    setTimeout(function () { sizeTiles(); update(); }, 800);
    var kernTries = 0;
    (function waitKern() { if (window.PHNWC_KERN || !cfg.kernUrl || kernTries++ > 25) { update(); return; } setTimeout(waitKern, 200); })();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-phn-configurator]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
